import React from 'react';

function Contact() {
  return (
    <div className="container mx-auto py-20 px-4">
      <h1 className="text-4xl font-bold text-indigo-700 mb-6">Contact Us</h1>
      <p className="text-lg text-gray-700 leading-relaxed">
        Reach out to us for more information. We are available via email or phone to answer any questions you may have.
      </p>
      <p className="text-lg text-gray-700 mt-4">
        Email: info@yourbrand.com<br />
        Phone: (123) 456-7890
      </p>
    </div>
  );
}

export default Contact;

